<template>
  <div>
    <el-table
      v-loading="loading"
      element-loading-text="加载中，请耐心等待。"
      :data="showTable"
      border
      style="width: 100%;margin-top: 10px"
      highlight-current-row>
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center">
      </el-table-column>
      <el-table-column
        prop="imei"
        label="IMEI"
        min-width="130"
        align="center">
      </el-table-column>
      <el-table-column
        prop="install_location"
        label="安装位置"
        min-width="80"
        align="center">
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        min-width="150"
        align="center">
      </el-table-column>
      <el-table-column
        label="推送状态"
        min-width="80"
        align="center">
        <template slot-scope="scope">
          <strong style="color: red" v-if="scope.row.tag === 1">已推送</strong>
          <strong style="color: green" v-else-if="scope.row.tag === 2">已阅读</strong>
          <span v-else>{{scope.row.tag}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="push_tm"
        label="推送时间"
        min-width="145"
        align="center">
      </el-table-column>
      <el-table-column
        label="阅读时间"
        min-width="145"
        align="center">
        <template slot-scope="scope">
          <span>{{showReadTm(scope.row)}}</span>
        </template>
      </el-table-column>
<!--      暂去-->
<!--      <el-table-column align="center" label="操作" width="50">-->
<!--        <template slot-scope="scope">-->
<!--          <i v-if="scope.row.hid !== 0" title="家庭联系人" class="el-icon-user-solid" style="font-size: 18px;color: blue;cursor: pointer" @click="openContact(scope.row)"></i>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog
      width="600px"
      title="家庭联系人"
      :visible.sync="familyShow"
      v-if="familyShow"
      :close-on-click-modal="false"
      append-to-body
      center>
      <family-contact :familyData="familyData" v-model="familyShow"></family-contact>
    </el-dialog>
  </div>
</template>

<script>
import {queryvoicemessagestatusbyvmid} from '../../../api/voice'
import familyContact from './familyContact'
export default {
  name: 'voiceDetails',
  components: {familyContact},
  model: {
    prop: 'openDetails',
    event: 'change'
  },
  props: {
    voiceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      loading: false,
      familyShow: false,
      familyData: {
        voiceRow: '',
        detailsMsg: ''
      }
    }
  },
  created () {
    this.row = this.voiceObj.voiceRow
    this.familyData.voiceRow = this.voiceObj.voiceRow
    this.getVoiceByMid()
  },
  mounted () {
  },
  methods: {
    getVoiceByMid () {
      this.loading = true
      let data = {
        vmid: this.row.id
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryvoicemessagestatusbyvmid(data, params).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.voicemessagestatus
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    openContact (row) {
      // console.log(row)
      this.familyData.detailsMsg = row
      this.familyShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getVoiceTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getVoiceTable()
    },
    getTagName (tag) {
      if (tag === 1) {
        return '已推送'
      } else if (tag === 2) {
        return '已阅读'
      }
    },
    showReadTm (row) {
      const stime = Date.parse(new Date(row.push_tm))
      const etime = Date.parse(new Date(row.read_tm))
      const usedTime = etime - stime
      if (usedTime > 0) {
        return row.read_tm
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/voiceDetails.vue